import useWidth from '../../../../components/Hooks/useWidth';
import UserMenuTrigger from '../UserMenu/UserMenuTrigger';

const HomeNavigationSidebarBottom = () => {
  const { mobileWidth: isMobile } = useWidth();

  if (!isMobile) {
    return null;
  }

  return <UserMenuTrigger />;
};

export default HomeNavigationSidebarBottom;
